export const RQ_GLOBAL_RULES = 'RQ_GLOBAL_RULES';
export const RQ_DEPLOYED_GLOBAL_RULES = 'RQ_DEPLOYED_GLOBAL_RULES';
export const RQ_DEPLOYED_LANDLORD_RULES = 'RQ_DEPLOYED_LANDLORD_RULES';
export const RQ_MERCHANT_RULES = 'RQ_MERCHANT_RULES';
export const RQ_DEPLOYED_MERCHANT_RULES = 'RQ_DEPLOYED_MERCHANT_RULES';
export const RQ_MERCHANT_OVERRIDES = 'RQ_MERCHANT_OVERRIDES';
export const RQ_DEPLOY_RULES = 'RQ_DEPLOY_RULES';
export const RQ_ALL_REPORTS = 'RQ_ALL_REPORTS';
export const RQ_DEPLOY_SUMMARY = 'RQ_DEPLOY_SUMMARY';
export const RQ_SINGLE_REPORT = 'RQ_SINGLE_REPORT';
export const RQ_SINGLE_REPORT_CSV = 'RQ_SINGLE_REPORT_CSV';
export const RQ_SINGLE_LIST_ENTRY = 'RQ_SINGLE_LIST_ENTRY';
export const RQ_ALL_DEPLOYMENTS = 'RQ_ALL_DEPLOYMENTS';
export const RQ_SINGLE_MERCHANT = 'RQ_SINGLE_MERCHANT';
export const RQ_SINGLE_DEPLOYMENT = 'RQ_SINGLE_DEPLOYMENT';
export const RQ_ALL_USERS = 'RQ_ALL_USERS';
export const RQ_TEMPLATE_ACQUIRER_CONFIG = 'RQ_TEMPLATE_ACQUIRER_CONFIG';
export const RQ_LATEST_DEPLOY_PROCESS = 'RQ_LATEST_DEPLOY_PROCESS';
export const RQ_LATEST_REPOSITORY = 'RQ_LATEST_REPOSITORY';
export const RQ_LATEST_REPOSITORY_CONFIG = 'RQ_LATEST_REPOSITORY_CONFIG';
export const RQ_HISTORY = 'RQ_HISTORY';
export const RQ_HISTORY_COUNT = 'RQ_HISTORY_COUNT';
export const RQ_LIST_TYPES = 'RQ_LIST_TYPES';
export const RQ_ADD_LIST = 'RQ_ADD_LIST';
export const RQ_ALL_LIST = 'RQ_ALL_LIST';
export const RQ_LIST_BY_ID = 'RQ_LIST_BY_ID';
export const RQ_ADD_NEW_LIST_ENTRY = 'RQ_ADD_NEW_LIST_ENTRY';
export const RQ_LIST_ENTRIES = 'RQ_LIST_ENTRIES';
export const RQ_LIST_ENTRIES_BULK = 'RQ_LIST_ENTRIES_BULK';
export const RQ_EDIT_LIST = 'RQ_EDIT_LIST';
export const RQ_USER_CONFIG = 'RQ_USER_CONFIG';
export const RQ_ALL_SIMULATIONS = 'RQ_ALL_SIMULATIONS';
export const RQ_SINGLE_SIMULATION = 'RQ_SINGLE_SIMULATION';
export const RQ_LAST_MINUTE_SIMULATIONS = 'RQ_LAST_MINUTE_SIMULATIONS';
export const RQ_SIMULATION_MODIFIED_RULES = 'RQ_SIMULATION_MODIFIED_RULES';
export const RQ_RULE_GROUPS = 'RQ_RULE_GROUPS';
export const RQ_ADD_RULE = 'RQ_ADD_RULE';
export const RQ_CREATE_GROUPS = 'RQ_CREATE_GROUPS';
export const RQ_DELETE_RULE_GROUP = 'RQ_DELETE_RULE_GROUP';
export const RQ_UPDATE_RULE_GROUP = 'RQ_UPDATE_RULE_GROUP';
export const RQ_RULE_REVISION_MERCHANT_OVERRIDES = 'RQ_RULE_REVISION_MERCHANT_OVERRIDES';
export const RQ_RULE_REVISION_TENANT_GROUP_OVERRIDES = 'RQ_RULE_REVISION_TENANT_GROUP_OVERRIDES';
export const RQ_LANDLORD_INFO = 'RQ_LANDLORD_INFO';
export const RQ_TENANTS = 'RQ_TENANTS';
export const RQ_TENANT_GROUPS = 'RQ_TENANT_GROUPS';
export const RQ_CREATE_TENANT_GROUP = 'RQ_CREATE_TENANT_GROUP';
export const RQ_UPDATE_TENANT_GROUP = 'RQ_UPDATE_TENANT_GROUP';
export const RQ_DELETE_TENANT_GROUP = 'RQ_DELETE_TENANT_GROUP';
export const RQ_TENANT_OVERRIDES = 'RQ_TENANT_OVERRIDES';
export const RQ_TENANT_GROUP_TENANTS = 'RQ_TENANT_GROUP_TENANTS';
export const RQ_UNGROUPED_TENANTS = 'RQ_UNGROUPED_TENANTS';
export const RQ_ADD_TENANTS_TO_TENANT_GROUP = 'RQ_ADD_TENANTS_TO_TENANT_GROUP';
export const RQ_DELETE_TENANTS_FROM_TENANT_GROUP = 'RQ_DELETE_TENANTS_FROM_TENANT_GROUP';
export const RQ_TENANT_GROUP_OVERRIDES = 'RQ_TENANT_GROUP_OVERRIDES';
export const RQ_TENANT_GROUP_INFORMATION = 'RQ_TENANT_GROUP_INFORMATION';
export const RQ_TENANT_GROUP_OVERRIDES_INHERITED = 'RQ_TENANT_GROUP_OVERRIDES_INHERITED';
export const RQ_ALL_CONCLUSION_FLAGS = 'RQ_ALL_CONCLUSION_FLAGS';
export const RQ_VALIDATE_RULE_EXPRESSION = 'RQ_VALIDATE_RULE_EXPRESSION';
export const RQ_VALIDATE_PARAMETER_EXPRESSION = 'RQ_VALIDATE_PARAMETER_EXPRESSION';
export const RQ_GET_INTELLISENSE_DATA = 'RQ_GET_INTELLISENSE_DATA';
export const RQ_GET_TENANT_GROUP = 'RQ_GET_TENANT_GROUP';
export const RQ_GET_REVISION_TENANT_GROUPS = 'RQ_GET_REVISION_TENANT_GROUPS';
export const RQ_GET_DEPLOYED_TENANT_GROUP_OVERRIDES = 'RQ_GET_DEPLOYED_TENANT_GROUP_OVERRIDES';
export const RQ_PARAMETERS = 'RQ_PARAMETERS';
export const RQ_PARAMETER_BY_ID = 'RQ_PARAMETER_BY_ID';
export const RQ_MANIFEST = 'RQ_MANIFEST';
export const RQ_TEMPLATE_CONFIG = 'RQ_TEMPLATE_CONFIG';
export const RQ_SCHEDULED_DEPLOYMENT = 'RQ_SCHEDULED_DEPLOYMENT';
export const RQ_SCHEDULED_DEPLOYMENT_DETAILS = 'RQ_SCHEDULED_DEPLOYMENT_DETAILS';
export const RQ_SCHEDULED_DEPLOYMENT_SUMMARY = 'RQ_SCHEDULED_DEPLOYMENT_SUMMARY';
export const RQ_CREATE_EXPRESSION_PARAMETER = 'RQ_CREATE_EXPRESSION_PARAMETER';
export const RQ_UPDATE_EXPRESSION_PARAMETER = 'RQ_UPDATE_EXPRESSION_PARAMETER';
export const RQ_CREATE_VELOCITY_PARAMETER = 'RQ_CREATE_VELOCITY_PARAMETER';
export const RQ_RULE_TESTER = 'RQ_RULE_TESTER';
export const RQ_CANCEL_RULE_TEST = 'RQ_CANCEL_RULE_TEST';
export const RQ_GET_RULE_TEST_RESULTS = 'RQ_GET_RULE_TEST_RESULTS';
export const RQ_GET_LIST_IMPORT_EXPORT_STATUS = 'RQ_GET_LIST_IMPORT_EXPORT_STATUS';
export const RQ_VELOCITY_CONFIGURATION = 'RQ_VELOCITY_CONFIGURATION';
